export enum ApplicationRouteEnum {
  ApplicationDetails = 'application-details',
  ApplicationList = 'applications',
}
